import * as React from 'react'

const ShortLeftArrow = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={17.984} viewBox="0 0 18 17.984" {...props}>
    <path
      id="Union_29"
      data-name="Union 29"
      d="M8.99,17.982,0,8.991,8.992,0V3.6l-4.08,4.08H18v2.632H4.911l4.081,4.082v3.6Z"
      fill="CurrentColor"
    />
  </svg>
)
export default ShortLeftArrow
